module.exports = __webpack_public_path__ + "static/list-6df4bfea528fd9512f360d29f4a4e975.png";